import * as RiIcons from "react-icons/ri";
import my_profile from "../../assets/sidebaricons/my-profile-icon.svg";
import my_profile_active from "../../assets/sidebaricons/my-profile-active.svg";
import skill_links from "../../assets/sidebaricons/Skill-links.svg";
import skill_links_active from "../../assets/sidebaricons/Skill-links-active.svg";
import internal_job from "../../assets/sidebaricons/internal-work.svg";
import internal_job_active from "../../assets/sidebaricons/Internal-work-active.svg";
import learning_development from "../../assets/sidebaricons/Learning-development.svg";
import learning_development_active from "../../assets/sidebaricons/Learning-development-active.svg";
import skill_coins from "../../assets/sidebaricons/Skill-coins.svg";
import skill_coins_active from "../../assets/sidebaricons/Skill-coins-active.svg";
import coaching_mentoring from "../../assets/sidebaricons/Coaching-mentoring.svg";
import coaching_mentoring_active from "../../assets/sidebaricons/Coaching-mentoring-active.svg";
import employee_db from "../../assets/sidebaricons/employeedb-icon.svg";
import employee_db_active from "../../assets/sidebaricons/employeedb-active.svg";
import resource_management from "../../assets/sidebaricons/resource-management.svg";
import resource_managemnet_active from "../../assets/sidebaricons/resource-management-active.svg";
import inseed_program from "../../assets/sidebaricons/inseed-program.svg";
import inseed_program_active from "../../assets/sidebaricons/inseed-program-active.png";
import rewards_and_recognitions from "../../assets/sidebaricons/rewards-and-recognition.svg";
import rewards_and_recognitions_active from "../../assets/sidebaricons/rewards-and-recognition-active.svg";
import { RiAdminLine, RiUserVoiceLine, RiDashboard3Line } from "react-icons/ri";


// Extra entry shown ONLY to managers (persona === "manager"): a team-scoped,
// score-only Resource Allocation. Appended to employeeSidebar in Sidebar.tsx.
export const managerResourceItem: any = {
  title: "Resource Allocation",
  path: "/manager/resource-allocation",
  icon: <img src={resource_management} alt="icon" className="sidebaricon" />,
  active_icon: (
    <img src={resource_managemnet_active} alt="icon" className="sidebaricon" />
  ),
  iconClosed: <RiIcons.RiArrowDownSFill />,
  iconOpened: <RiIcons.RiArrowUpSFill />,
};

// The Succession Planning section — shared by HR and (team-scoped) managers.
export const successionPlanningItem: any = {
  title: "Succession Planning",
  path: "/succession-planning/critical-roles",
  icon: <RiIcons.RiOrganizationChart size={20} />,
  active_icon: <RiIcons.RiOrganizationChart size={20} />,
  iconClosed: <RiIcons.RiArrowDownSFill />,
  iconOpened: <RiIcons.RiArrowUpSFill />,
  subNav: [
    { title: "Critical Roles", path: "/succession-planning/critical-roles" },
    { title: "Development Plan", path: "/succession-planning/development-plan" },
    { title: "Dashboard", path: "/succession-planning/dashboard" },
  ],
};

export const employeeSidebar: any = [
  {
    title: "Profile",
    path: "/profile",
    icon: <img src={my_profile_active} alt="icon" className="sidebaricon" />,
    active_icon: <img src={my_profile} alt="icon" className="sidebaricon" />,
    iconClosed: <RiIcons.RiArrowDownSFill />,
    iconOpened: <RiIcons.RiArrowUpSFill />,
  },
  {
    title: "Skill Links",
    path: "/refer-resource",
    icon: <img src={skill_links} alt="icon" className="sidebaricon" />,
    active_icon: (
      <img src={skill_links_active} alt="icon" className="sidebaricon" />
    ),
    iconClosed: <RiIcons.RiArrowDownSFill />,
    iconOpened: <RiIcons.RiArrowUpSFill />,

    subNav: [
      { title: "Refer a Resource", path: "/refer-resource" },
      {
        title: "Referred List",
        path: "/referred-list",
      },
    ],
  },
  // Ticket #235 - Hidden: Internal Job Posting
  // {
  //   title: "Internal Job Posting",
  //   path: "/jobpost",
  //   icon: <img src={internal_job} alt="icon" className="sidebaricon" />,
  //   active_icon: (
  //     <img src={internal_job_active} alt="icon" className="sidebaricon" />
  //   ),
  // },
  // Ticket #235 - Hidden: Learning & Development
  // {
  //   title: "Learning & Development",
  //   path: "/courses",
  //   icon: <img src={learning_development} alt="icon" className="sidebaricon" />,
  //   active_icon: (
  //     <img
  //  src={learning_development_active}
  //  alt="icon"
  //  className="sidebaricon"
  //  />
  //   ),
  //   iconClosed: <RiIcons.RiArrowDownSFill />,
  //   iconOpened: <RiIcons.RiArrowUpSFill />,
  //   subNav: [
  //     {
  //       title: `Manager Requests`,
  //       path: "/enrollment-manager-request",
  //     },
  //     {
  //       title: `Finance Requests`,
  //       path: "/enrollment-finance-request",
  //     },
  //     {
  //       title: "Courses",
  //       path: "/courses",
  //     },
  //   ],
  // },
  // Ticket #235 - Hidden: Skill Coins
  //{
  //   title: "Skill Coins",
  //   path: "/skillcoins-redeem",
  //   icon: <img src={skill_coins} alt="icon" className="sidebaricon" />,
  //   active_icon: (
  //     <img src={skill_coins_active} alt="icon" className="sidebaricon" />
  //   ),
  //   iconClosed: <RiIcons.RiArrowDownSFill />,
  //   iconOpened: <RiIcons.RiArrowUpSFill />,
  // },
  // Ticket #235 - Hidden: Coaching & Mentoring
  // {
  //   title: "Coaching & Mentoring",
  //   path: "/coaching-request",
  //   icon: <img src={coaching_mentoring} alt="icon" className="sidebaricon" />,
  //   active_icon: (
  //     <img src={coaching_mentoring_active} alt="icon" className="sidebaricon" />
  //   ),
  //   iconClosed: <RiIcons.RiArrowDownSFill />,
  //   iconOpened: <RiIcons.RiArrowUpSFill />,
  //   subNav: [
  //     {
  //       title: `Manager Requests`,
  //       path: "/enrollment-manager-request",
  //     },
  //     {
  //       title: `Finance Requests`,
  //       path: "/enrollment-finance-request",
  //     },
  //     {
  //       title: "Courses",
  //       path: "/courses",
  //     },
  //   ],
  // },
  {
    title: "Skill Coins",
    path: "/skillcoins-redeem",
    icon: <img src={skill_coins} alt="icon" className="sidebaricon" />,
    active_icon: (
      <img src={skill_coins_active} alt="icon" className="sidebaricon" />
    ),
    iconClosed: <RiIcons.RiArrowDownSFill />,
    iconOpened: <RiIcons.RiArrowUpSFill />,
  },
  // {
  //   title: "Coaching & Mentoring",
  //   path: "/coaching-request",
  //   icon: <img src={coaching_mentoring} alt="icon" className="sidebaricon" />,
  //   active_icon: (
  //     <img src={coaching_mentoring_active} alt="icon" className="sidebaricon" />
  //   ),
  //   iconClosed: <RiIcons.RiArrowDownSFill />,
  //   iconOpened: <RiIcons.RiArrowUpSFill />,

  //   subNav: [
  //     {
  //       title: "Be A Coach",
  //       path: "/be-a-coach",
  //     },
  //     {
  //       title: "Request A Coach",
  //       path: "/coaching-request",
  //     },
  //   ],
  // },
];

export const hrSidebar: any = [
  {
    title: "Employee Database",
    path: "/",
    icon: <img src={employee_db} alt="icon" className="sidebaricon" />,
    active_icon: (
      <img src={employee_db_active} alt="icon" className="sidebaricon" />
    ),
    iconClosed: <RiIcons.RiArrowDownSFill />,
    iconOpened: <RiIcons.RiArrowUpSFill />,

    subNav: [
      {
        title: "Employee Database",
        path: "/",
      },
      {
        title: "Profile",
        path: "/profile",
      },
      {
        title: "Reports",
        path: "/employeedb-reports",
      },
    ],
  },

  {
    title: "Resource Management",
    path: "/project-repository",
    icon: (
      <img src={resource_management} alt="icon" className="sidebaricon mb-3" />
    ),
    active_icon: (
      <img
        src={resource_managemnet_active}
        alt="icon"
        className="sidebaricon"
      />
    ),
    iconClosed: <RiIcons.RiArrowDownSFill />,
    iconOpened: <RiIcons.RiArrowUpSFill />,
    subNav: [
      {
        title: "Project Repository",
        path: "/project-repository",
      },
      {
        title: "Resource Allocation",
        path: "/resource-allocation",
      },
      {
        title: "Bench Management",
        path: "/bench-management",
      },
    ],
  },
  {
    title: "Skill Links",
    path: "/post-a-job",
    icon: <img src={skill_links} alt="icon" className="sidebaricon" />,
    active_icon: (
      <img src={skill_links_active} alt="icon" className="sidebaricon" />
    ),
    iconClosed: <RiIcons.RiArrowDownSFill />,
    iconOpened: <RiIcons.RiArrowUpSFill />,

    subNav: [
      {
        title: "Post a Job",
        path: "/post-a-job",
      },
      {
        title: "Refer a Resource",
        path: "/refer-resource",
      },
      {
        title: "Eligible Referral Payouts",
        path: "/eligble-payout-list",
      },
      {
        title: "Employee Referral History",
        path: "/employee-referral-history",
      },
      {
        title: "Referred List",
        path: "/referred-list",
      },
    ],
  },
  // Ticket #235 - Hidden: Internal Job Posting
  // {
  //   title: "Internal Job Posting",
  //   path: "/jobpost",
  //   icon: <img src={internal_job} alt="icon" className="sidebaricon" />,
  //   active_icon: (
  //     <img src={internal_job_active} alt="icon" className="sidebaricon" />
  //   ),
  //   iconClosed: <RiIcons.RiArrowDownSFill />,
  //   iconOpened: <RiIcons.RiArrowUpSFill />,
  //   subNav: [
  //     {
  //       title: `Post a Job to IJP`,
  //       path: "/ijp-post-a-job",
  //     },
  //     {
  //       title: "Internal Job Posting",
  //       path: "/jobpost",
  //     },
  //   ],
  // },
  // Ticket #235 - Hidden: Learning & Development
  //{
  //  title: "Learning & Development",
  //  path: "/courses",
  //  icon: <img src={learning_development} alt="icon" className="sidebaricon" />,
  //  active_icon: (
  //    <img
  //      src={learning_development_active}
  //      alt="icon"
  //     className="sidebaricon"
  //    />
  //  ),
  //  iconClosed: <RiIcons.RiArrowDownSFill />,
  //  iconOpened: <RiIcons.RiArrowUpSFill />,

  //   subNav: [
  //     {
  //       title: `HR Requests`,
  //       path: "/enrollment-request",
  //     },
  //     {
  //       title: `Manager Requests`,
  //       path: "/enrollment-manager-request",
  //     },
  //     {
  //       title: `Finance Requests`,
  //       path: "/enrollment-finance-request",
  //     },
  //     {
  //       title: "Courses",
  //       path: "/courses",
  //     },
  //   ],
  // },
  {
    title: "Skill Coins",
    path: "/skill-coins",
    icon: <img src={skill_coins} alt="icon" className="sidebaricon" />,
    active_icon: (
      <img src={skill_coins_active} alt="icon" className="sidebaricon" />
    ),
    iconClosed: <RiIcons.RiArrowDownSFill />,
    iconOpened: <RiIcons.RiArrowUpSFill />,
    subNav: [
      {
        title: `Skill Coins`,
        path: "/skill-coins",
      },
      {
        title: `Redeem Skill Coins`,
        path: "/skillcoins-redeem",
      },
    ],
  },
  {
    title: "Inseed Program",
    path: "/inseed-master",
    icon: <img src={inseed_program} alt="icon" className="sidebaricon" />,
    active_icon: (
      <img src={inseed_program_active} alt="icon" className="sidebaricon" />
    ),
    iconClosed: <RiIcons.RiArrowDownSFill />,
    iconOpened: <RiIcons.RiArrowUpSFill />,

    subNav: [
      {
        title: "Inseed Master",
        path: "/inseed-master",
      },
      {
        title: "Module Master",
        path: "/module-master",
      },
      {
        title: "Trainee Master",
        path: "/trainee-master",
      },
      {
        title: "Training Schedule",
        path: "/training-schedule",
      },
      {
        title: "Assessment Master",
        path: "/assessment-master",
      },
      {
        title: "Final Evaluation",
        path: "/evaluation",
      },
    ],
  },
  // Ticket #235 - Hidden: Coaching & Mentoring
  // {
  //   title: "Coaching & Mentoring",
  //   path: "/coaching-request",
  //   icon: <img src={coaching_mentoring} alt="icon" className="sidebaricon" />,
  //   active_icon: (
  //     <img src={coaching_mentoring_active} alt="icon" className="sidebaricon" />
  //   ),
  //   iconClosed: <RiIcons.RiArrowDownSFill />,
  //   iconOpened: <RiIcons.RiArrowUpSFill />,

  //   subNav: [
  //     {
  //       title: "Be A Coach",
  //       path: "/be-a-coach",
  //     },
  //     {
  //       title: "Request A Coach",
  //       path: "/coaching-request",
  //     },
  //     {
  //       title: "Coaching Requests",
  //       path: "/all-coaching-requests",
  //     },
  //     {
  //       title: "Coaching Reports",
  //       path: "/coaching-reports",
  //     },
  //   ],
  // },
  {
    title: "Rewards and Recognition",
    path: "/rewards-and-recognition/awards",
    icon: <img src={rewards_and_recognitions} alt="icon" className="sidebaricon" />,
    active_icon: (
      <img src={rewards_and_recognitions_active} alt="icon" className="sidebaricon" />
    ),
    iconClosed: <RiIcons.RiArrowDownSFill />,
    iconOpened: <RiIcons.RiArrowUpSFill />,
    subNav: [
      {
        title: "Awards Management",
        path: "/rewards-and-recognition/awards",
      },
      {
        title: "Employee Nomination",
        path: "/rewards-and-recognition/nomination-employees",
      },
      {
        title: "Nomination Approval",
        path: "/rewards-and-recognition/nomination-list",
      }
    ],
  },
  {
    title: "Succession Planning",
    path: "/succession-planning/critical-roles",
    icon: <RiIcons.RiOrganizationChart size={20} />,
    active_icon: <RiIcons.RiOrganizationChart size={20} />,
    iconClosed: <RiIcons.RiArrowDownSFill />,
    iconOpened: <RiIcons.RiArrowUpSFill />,
    subNav: [
      {
        title: "Critical Roles",
        path: "/succession-planning/critical-roles",
      },
      {
        title: "Development Plan",
        path: "/succession-planning/development-plan",
      },
      {
        title: "Dashboard",
        path: "/succession-planning/dashboard",
      },
    ],
  },
  {
    title: "Role Management",
    path: "/role-management",
    icon: <RiAdminLine size={20} />,
    active_icon: <RiAdminLine size={20} />,
    iconClosed: <RiIcons.RiArrowDownSFill />,
    iconOpened: <RiIcons.RiArrowUpSFill />,
    subNav: [
      {
        title: "Admin",
        path: "/role-management",
      },
      {
        title: "KRA",
        path: "/role-management/kra",
      },
      {
        title: "Designation",
        path: "/role-management/designation",
      },
    ],
  },
  {
    title: "HRBP Tracker",
    path: "/HRBP-Tracker",
    icon: <RiDashboard3Line size={20} />,
    active_icon: <RiDashboard3Line size={20} />,
    iconClosed: <RiIcons.RiArrowDownSFill />,
    iconOpened: <RiIcons.RiArrowUpSFill />,
  },
  {
    title: "Insurance Cost Dashboard",
    path: "/onsurity/cost-dashboard",
    icon: <RiIcons.RiMoneyDollarCircleLine size={20} />,
    active_icon: <RiIcons.RiMoneyDollarCircleLine size={20} />,
    iconClosed: <RiIcons.RiArrowDownSFill />,
    iconOpened: <RiIcons.RiArrowUpSFill />,
    // Self-referencing subNav — the only way SubMenu shows a name popup on hover is via
    // the subNav flyout, even for a single-destination item like this one.
    subNav: [
      {
        title: "Insurance Cost Dashboard",
        path: "/onsurity/cost-dashboard",
      },
    ],
  },
  // {
  //   title: "chatBot Management",
  //   path: "/chat-bot",
  //      icon: <RiUserVoiceLine size={20} />,
  //   active_icon: (
  //     <RiUserVoiceLine size={20} />
  //   ),
  //   iconClosed: <RiIcons.RiArrowDownSFill />,
  //   iconOpened: <RiIcons.RiArrowUpSFill />,
  // }
];
